const state = {
  notice: {
    type: 'info',
    message: '',
    title: ''
  },
  sysTheme: 'norm'
}

let sysThemeList = ['norm', 'dark']

const getters = {
  notice: state => state.notice,
  sysTheme: state => state.sysTheme
}

const actions = {
  showNoticeMsg ({ commit }, data) {
    commit('setNoticeMsg', data)
  },
  setSysTheme ({ commit }, data) {
    if (sysThemeList.includes(data)) {
      commit('setSysTheme', data)
    }
  }
}

const mutations = {
  setNoticeMsg (state, data) {
    let newData = {
      type: data.type || 'info',
      message: data.message,
      title: data.title || '系统提示'
    }
    state.notice = newData
  },
  setSysTheme (state, data) {
    state.sysTheme = data
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/global_events.js